module.exports = __webpack_public_path__ + "img/v1-11.4da30288.png";